import React, { useEffect } from 'react';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';

import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import ButtonOwnDays from '../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';

import './HomeCarousel.scss';
import { odPushGA4Event } from '../../../utils/gaFour';

const defaultSettings = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  pauseOnHover: false,
  pauseOnFocus: false,
};

const HomeCarousel = ({ banners }) => {
  const dispatch = useDispatch();
  const sliderRef = React.useRef(null);
  const userInfo = useSelector(state => state.common.userInfo);

  const handleBeforeChange = (current, next) => {
    const visibleBanner = banners[next];
    if (visibleBanner) {
      // eslint-disable-next-line no-console
      odPushGA4Event('banner_viewed', {
        screenName: 'home-page',
        title: visibleBanner.title,
        type: visibleBanner.type || 'image',
        userInfo,
      });
    }
  };

  const carouselSettings = {
    ...defaultSettings,
    beforeChange: handleBeforeChange,
    ref: sliderRef,
    onSwipe: () => {
      odPushGA4Event('carousal_swipe', {
        screenName: 'home-page',
        userInfo,
      });
    },
  };

  useEffect(() => {
    dispatch(showGlobalHeaderFooter({ header: false, footer: true, secondaryHeader: true }));
  }, [dispatch]);

  const handleClick = href => {
    window.location.assign(href);
  };

  const customShouldDisplay = title => {
    const now = new Date();
    const isPreProd = process.env.ENVIRONMENT === 'preprod';

    if (title === `Junni Kids Glasses`) {
      const releaseTime = new Date('2025-07-18T10:00:00+08:00');
      let shouldDisplay = true;

      if (isPreProd) {
        return true;
      }
      const isBeforeRelease = now < releaseTime;
      if (isBeforeRelease) shouldDisplay = !isBeforeRelease;

      return shouldDisplay;
    }

    return true;
  };

  const filterBanners = banners.filter(banner => {
    const { startDeactivate, endDeactivate } = banner;
    const currentDate = new Date().toISOString();

    return (
      (!startDeactivate && !endDeactivate) || // No deactivation period
      (startDeactivate &&
        endDeactivate &&
        !(startDeactivate < currentDate && endDeactivate > currentDate)) || // Deactivation range excludes current date
      (startDeactivate && !endDeactivate && startDeactivate >= currentDate) // Only startDeactivate exists and excludes current date
    );
  });

  return (
    <div className="od-home-carousel">
      <Slider {...carouselSettings} className="slick--main">
        {filterBanners.map((banner, index) => {
          if (banner?.type === 'video' && customShouldDisplay(banner.title)) {
            return (
              <section key={index} id="od-home-carousel-video">
                <video
                  playsInline
                  autoPlay={banner?.autoPlay}
                  loop={banner?.loop}
                  muted={banner?.muted}
                  src={banner?.src}
                >
                  <track default kind="captions" label="English" src={banner?.src} />
                </video>
                <div className="od-home-carousel__action">
                  <div className="od-home-carousel__action__title">{banner?.title}</div>
                  <ButtonOwnDays
                    fontClass="od-font-reg"
                    fontSize="20px"
                    mode="oval-white"
                    px="40px"
                    py="12px"
                    text={banner?.button?.text}
                    onClick={() => handleClick(banner?.button.href)}
                  />
                </div>
              </section>
            );
          }

          return (
            customShouldDisplay(banner.title) && (
              <a
                key={`${banner?.title}-${index}`}
                href={banner?.button?.href}
                onClick={() => {
                  odPushGA4Event('carousal_clicks', {
                    screenName: 'home-page',
                    title: banner.title,
                    type: banner.type || 'image',
                    userInfo,
                  });
                }}
              >
                <picture className="carousel-container">
                  <source
                    media="(min-width:1296px)"
                    srcSet={banner?.src.pc || banner?.src}
                    type="image/webp"
                  />
                  <source
                    media="(min-width:768px)"
                    srcSet={banner?.src.tb || banner?.src}
                    type="image/webp"
                  />
                  <img
                    alt={banner?.title}
                    className="carousel-item"
                    src={banner?.src.sp || banner?.src}
                  />
                </picture>
              </a>
            )
          );
        })}
      </Slider>
    </div>
  );
};

export default HomeCarousel;
